import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";

export const ScheduleBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedScheduleCount = 0,
        onScheduleBulkPause,
        onScheduleBulkResume,
        onScheduleBulkDelete,
    } = options;

    const heading = `${pluralizeWithCount("schedule", selectedScheduleCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onScheduleBulkPause && (
                <CommandItem
                    keywords={["pause"]}
                    onSelect={onScheduleBulkPause}
                >
                    Pause
                </CommandItem>
            )}
            {onScheduleBulkResume && (
                <CommandItem
                    keywords={["resume"]}
                    onSelect={onScheduleBulkResume}
                >
                    Resume
                </CommandItem>
            )}
            {onScheduleBulkDelete && (
                <CommandItem
                    keywords={["delete", "remove"]}
                    shortcut="delete"
                    onSelect={onScheduleBulkDelete}
                >
                    Delete
                </CommandItem>
            )}
        </Command.Group>
    );
};
